import common from "../modules/common";
import helpers from "../utils/helpers";

const single = {
    init: function () {
        single.events();
    },

    events: function () {

        $('.news__slider').on('init', function () {
            common.bLazy.load($('.news__image'));
            $('.dot-resize-update').dotdotdot('update');
        })

        $('.news__slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: false,
            dots: false,
            arrows: true,
            prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="10" viewBox="0 0 16 10"> <defs> <polygon id="arrow-left-a" points="18 15 12 20.06 18 25 18 21 28 21 28 19 18 19"/> </defs> <use fill="#212B36" transform="translate(-12 -15)" xlink:href="#arrow-left-a"/></svg></span>',
            nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="10" viewBox="0 0 16 10"> <defs> <polygon id="arrow-right-a" points="18 15 12 20.06 18 25 18 21 28 21 28 19 18 19"/> </defs> <use fill="#212B36" transform="rotate(-180 14 12.5)" xlink:href="#arrow-right-a"/></svg></span>',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ],
        });

        if ($('.soc-share').length) {
            $('body').on('click', '.soc-share', function (e) {
                e.preventDefault();

                var platform = $(this).attr('data-platform');
                var data = $(this).attr('data-content');

                helpers.share(platform, data);
            });
        }
    },
};

export default single;